import { createSlice } from '@reduxjs/toolkit'
import { defaultDropdowns, defaultSnackbarState, getYearDropdownTillNow, initialStateRouteParams } from '../utils/helper'
import { REDUX_FILTER_POLLS } from '../utils/constants'

const initialState = {
  shouldVerifyDetails: false,
  showVerifyDetailsModal: false,
  userData: null,
  snackBar: defaultSnackbarState,
  dropdowns: {
    ...defaultDropdowns,
    yearsDescending: getYearDropdownTillNow(),
    callStatus: [],
  },
  stateRouteParams: { ...initialStateRouteParams },
  filters: {
    boothwiseGraph: null,
    [REDUX_FILTER_POLLS]: null,
  },
  dashboardCounts: {},
  sheetsHavingErrors: [],
  importApiLoading: false
}

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setReduxState: (state, action) => {
      const { name, value } = action.payload;

      if (name === "dropdowns") {
        // Merge new dropdowns with existing ones
        state.dropdowns = { ...state.dropdowns, ...value };
      } else {
        state[name] = value;
      }
    },

    setCallStatusDropdown: (state, action) => {
      state.dropdowns.callStatus = action.payload;
    },
  },
})

export const { setReduxState } = appSlice.actions

export default appSlice.reducer